module.exports = __webpack_public_path__ + "static/media/cms.a090138c.svg";